export default function createWebhookType(data) {
  return {
    id: data.id,
    name: data.name,
    type: data.type,
  };
}
